import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import App from './AppNew1';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
} from "react-router-dom";
import Home from './widgets/Home';
import AboutMe from './widgets/AboutMe';
import ExperiencesNew from './widgets/ExperienceNew';
import ProjectsNew from './widgets/ProjectsNew';
import Myposts from './widgets/Blogs';
import Contact from './widgets/Contact';
import PostsPage from './widgets/BlogPage';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAevoliKX3OiXq4fPNovZhkNmgMDrkF-iU",
  authDomain: "patnala1-8482d.firebaseapp.com",
  databaseURL: "https://patnala1-8482d-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "patnala1-8482d",
  storageBucket: "patnala1-8482d.appspot.com",
  messagingSenderId: "870911648161",
  appId: "1:870911648161:web:7d592fb0895157c2adebe0",
  measurementId: "G-Q62ZDXTYWS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "about-me",
        element: <AboutMe />,
      },
      {
        path: "experience",
        element: <ExperiencesNew />,
      },
      {
        path: "projects",
        element: <ProjectsNew />,
      },
      {
        path: "blogs",
        element: <Myposts />,
      },
      {
        path : "contact",
        element : <Contact/>
      },
      {
        path : "blogsPage/:id",
        element : <PostsPage/>
      }
    ],
  },

]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

reportWebVitals();
